<template>
  <div class="home">
	    <div class="box">	
            <div class="notification is-warning" v-if="loading === true">
                Loading ...
            </div>
            <div class="level" v-if="loading === false">
            <div class="level-left">
                <h2 class="title">Organisations For {{volunteer.forename }} {{volunteer.surname}}</h2>
                    </div>
                    <div class="level-right">
                        <router-link :to="'/volunteers/' + this.$route.params.id" class="button is-small is-link">Back to Volunteer Details</router-link>
                        </div>
            </div>


            <table class="table is-hoverable is-fullwidth" v-if="loading === false">
                <thead>
                        <tr>
                    <th>Name</th>
                    <th width="50">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="row in organisations" :key="row.id">
                        <td>{{ row.name }}</td>
                        <td>
                            <button class="button is-small is-success" v-if="already_assigned(row.id) == false" @click="saveUserOrganisation(row.id)">Assign to Organisation</button>
                            <button class="button is-small is-warning" v-if="already_assigned(row.id) == true">Already Assigned</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
		
	</div>
</template>

<script>
import AwardsService from '@/services/AwardsService.js';
import AwardsMixin from '@/mixins/AwardsMixin.js';




export default {
  name: 'AddAward',
	mixins: [AwardsMixin],
	data: function () {
    	return {
		      loading : true,
			  search: "",
				API_NAME: process.env.VUE_APP_API_NAME,
				accessToken: '',
                volunteer: {organisations:[], awards: []},
        organisations:[],
        
        user_id: this.$route.params.id,
        
		}
	},
	created() {
      this.getAccessToken()
        .then(() => { 
           this.getUserProfile();
           this.getOrganisations();
           this.getVolunteer();
        });
      
    },
	methods: {
		async getAccessToken() {
            this.accessToken = await this.$auth.getTokenSilently()
        },
		async saveUserOrganisation(organisation_id) {
           
            this.loading = true;

            var formdata = { 
                
                organisation_id : organisation_id,
                user_id : this.user_id,
            }; 

            AwardsService.saveUserOrganisation(this.accessToken, formdata)
            .then((response) => {
                
                this.getVolunteer();
                console.log(response)
                
                }).catch((error) => {
                    if(error.response.status === 422)
                    {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields.")
                    this.loading = false;
            });
            

			
		},
        already_assigned(id)
        {
            let already_assigned = false
            for(let i = 0;i < this.volunteer.organisations.length; i++ ) {
               if( this.volunteer.organisations[i].id == id)
               {
                already_assigned = true
               }
            }

            return already_assigned
        }
       
		
	},
    watch: {
       
    },
    computed: {
		
	}
    
}
</script>
